/// <reference path="../modules/app.module.ts" />
/// <reference path="../services/navigation.service.ts" />

module App.Controllers {
    export interface IShellController {

    }

    export class ShellController implements IShellController {
        static controllerId = 'shellController';

        static $inject = [
            '$rootScope',
            Blocks.RouterFactory.factoryId,
            App.Services.NavigationService.serviceId
            
        ];

        constructor(private $rootScope: Interfaces.IAppRootScope, private routerFactory: Blocks.Interfaces.IRouterFactory, private navigationService: App.Interfaces.INavigationService) {
            //if (routerFactory.currentState.abstract)
            //    navigationService.goToStep(Constants.routeKeys.cardetail);
        }

        get loading() {
            return this.$rootScope.loading;
        }
    }

    app.controller(ShellController.controllerId, ShellController);
}